import api from "../services/api";

let cached = null;

/* Fetches the school's identity (name, logo, contact) from General Settings.
   Cached in-memory per page load — call resetSchoolInfoCache() after saving settings. */
export const getSchoolInfo = async () => {
  if (cached) return cached;
  try {
    const res = await api.get("/api/general-settings/public");
    cached = res.data?.data || { schoolName: "EduNext" };
  } catch {
    cached = { schoolName: "EduNext" };
  }
  return cached;
};

export const resetSchoolInfoCache = () => { cached = null; };
